// Nach einem Deployment gibt es die Programmteile (Chunks) der alten Version nicht mehr. Eine offene Seite, die erst
// jetzt z. B. „Vertrieb“ nachlädt, bekäme 404 und die Fehlerseite. Stattdessen einmal neu laden – dann kommen
// index.html und alle Teile der neuen Version (höchstens einmal je Minute, damit nie eine Schleife entsteht).

const KEY = 'em-chunk-reload-at';

export function isChunkLoadError(error: unknown): boolean {
  const msg = error instanceof Error ? `${error.name} ${error.message}` : String(error ?? '');
  return /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Unable to preload CSS|ChunkLoadError/i.test(msg);
}

// reloadForNewVersion lädt die Seite neu, wenn das in der letzten Minute nicht schon passiert ist; true = lädt neu.
export function reloadForNewVersion(): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < 60_000) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    return false;
  }
  window.location.reload();
  return true;
}
